import { render } from "./TeamDirectoryView.vue?vue&type=template&id=b711debc&scoped=true"
import script from "./TeamDirectoryView.vue?vue&type=script&lang=js"
export * from "./TeamDirectoryView.vue?vue&type=script&lang=js"

import "./TeamDirectoryView.vue?vue&type=style&index=0&id=b711debc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b711debc"]])

export default __exports__